<template>
  <gj-modal
    :visible.sync="modalVisible"
    :destroyOnClose="true"
    size="full"
    :noPadding="true"
    style="padding: 0 10px"
    :content-style="{ height: '100%' }"
    :confirm-loading="loading"
    @cancel="cancel"
    @confirm="confirm"
  >
    <template #header>
      <span>批量修改买家自配送库存, 已选{{ tableForm.items.length }}数据</span>
    </template>
    <template #content>
      <div class="offer--content">
        <div class="offer--setting">
          <el-form :model="form" ref="form" label-width="140px">
            <el-row type="flex">
              <el-form-item
                class="el-item-inline"
                prop="mfnFulfillmentLatency"
                label="卖家自配送备货时间"
              >
                <gj-input width="120px" v-model="form.mfnFulfillmentLatency"> </gj-input>
              </el-form-item>
              <el-form-item class="el-item-inline" prop="mfnQuantity" label="卖家自配送库存">
                <!--                上调下调select-->
                <gj-select
                  class="no-left-radius"
                  :filterable="false"
                  :clearable="false"
                  width="100px"
                  v-model="mfnQuantityChange"
                  :options="option"
                ></gj-select>

                <gj-input
                  :class="{ 'no-left-border': true }"
                  width="120px"
                  v-model="form.mfnQuantity"
                  @change="verify"
                >
                </gj-input>
              </el-form-item>
              <div class="apply-btn">
                <gj-button @click="resolve">应用</gj-button>
              </div>
            </el-row>
          </el-form>
        </div>

        <el-form :model="tableForm" ref="tableForm" style="display: flex; height: 100%">
          <div class="offer--table">
            <gj-table
              name="relate-product"
              :data="tableForm.items"
              :columns="columns"
              :size="'has-picture'"
              :loading="loading"
              :offsetHeight="74"
            >
              <template v-slot:asin="{ row }">
                <gj-tooltip :text-line="1" :content="row.title">
                  {{ row.title }}
                </gj-tooltip>

                <div class="asin-msku_list">
                  <div class="asin_list">
                    <a :href="row.asinUrl" target="_blank">{{ row.asin }}</a>
                    <span
                      v-if="row.asin"
                      v-copy="row.asin"
                      class="copy-icon gj-cell-display-switch"
                    >
                      <gj-icon class="el-icon-copy-document"></gj-icon>
                    </span>
                  </div>
                  <div class="msku_list">
                    <gj-tooltip :text-line="1" :content="row.msku">
                      {{ row.msku || '-' }}
                    </gj-tooltip>
                    <span
                      v-copy="row.msku"
                      v-if="row.msku"
                      class="copy-icon gj-cell-display-switch"
                    >
                      <gj-icon class="el-icon-copy-document"></gj-icon>
                    </span>
                  </div>
                </div>
              </template>

              <template v-slot:mfnQuantity="{ row, index }">
                <el-form-item
                  :prop="`items.${index}.mfnQuantity`"
                  :rules="[
                    { required: true, message: '请输入卖家自配送库存', trigger: 'blur' },
                    $gjReRule(RE.pt0, '请输入整数'),
                  ]"
                  class="gj-table-item"
                >
                  <gj-input
                    style="z-index: 1"
                    width="120px"
                    @change="tableVerify"
                    v-model="row.mfnQuantity"
                  >
                  </gj-input>
                </el-form-item>
              </template>

              <template v-slot:mfnFulfillmentLatency="{ row, index }">
                <el-form-item
                  :prop="`items.${index}.mfnFulfillmentLatency`"
                  :rules="[
                    { required: true, message: '请输入卖家自配送备货时间', trigger: 'blur' },
                    $gjReRule(RE.pt0, '请输入整数'),
                  ]"
                  class="gj-table-item"
                >
                  <gj-input
                    style="z-index: 1"
                    width="120px"
                    @change="tableVerify"
                    v-model="row.mfnFulfillmentLatency"
                  >
                  </gj-input>
                </el-form-item>
              </template>
              <template v-slot:op="{ index, row }">
                <template v-if="tableForm.items.length !== 1">
                  <gj-button type="text" @click="deleteItem(index, row)">删除</gj-button>
                </template>
              </template>
            </gj-table>
          </div>
        </el-form>
      </div>
    </template>
  </gj-modal>
</template>

<script>
import { formRuleMixin, modalMixIn } from '../../../../../minxins';
import { editBatchEditFulfillment, batchEditMfnQuantityDetail } from '../../../../../api/sale';
import { mapGetters } from 'vuex';

export default {
  name: 'app-product-offer-modal',
  mixins: [modalMixIn, formRuleMixin],
  computed: {
    ...mapGetters({
      marketOption: 'marketOption',
    }),
    // treeConfig() {
    //   return this.whetherToShowFlag ? this.staticTreeConfig : null;
    //   return this.staticTreeConfig
    // },
  },
  props: {
    rows: null,
  },
  created() {
    this.getList();
  },
  data() {
    return {
      form: {
        mfnFulfillmentLatency: '',
        mfnQuantity: '',
      },

      mfnQuantityChange: 'fixed',

      keep: false,

      option: [
        { id: 'fixed', text: '固定值' },
        { id: 'up', text: '上调' },
        { id: 'down', text: '下调' },
      ],
      tableForm: {
        items: [],
      },
      columns: [
        { id: 'picture', header: '图片', field: 'picture:imageUrl', minWidth: '50px' },
        { id: 'asin', header: '商品标题/ASIN/父ASIN', field: 'slot:asin', minWidth: '250px' },
        { id: 'msku', header: 'MSKU', field: 'msku', minWidth: '120px' },
        {
      id: 'marketId',
      header: '店铺/国家',
      field: 'option:marketId',
      minWidth: '120px',
      default: true,
      options: () => this.marketOption,
    },
        { id: 'fulfillment', header: '配送渠道', field: 'fulfillment', minWidth: '120px' },

        {
          id: 'mfnFulfillmentLatency',
          header: '卖家自配送备货时间',
          field: 'slot:mfnFulfillmentLatency',
          minWidth: '120px',
        },
        {
          id: 'mfnQuantity',
          header: '卖家自配送库存',
          field: 'slot:mfnQuantity',
          minWidth: '120px',
        },
        { id: 'op', header: '操作', field: 'slot:op', width: '80px', notCustomColumn: true },
      ],
      type: 0,
      loading: false,
    };
  },
  methods: {
    getList() {
      this.loading = true;
      let ids = [];
      this.rows.forEach((item) => {
        if (item.isVariant) {
          ids = ids.concat(item.ids);
        } else {
          ids.push(item.id);
        }
      });
      batchEditMfnQuantityDetail({ ids })
        .then((data) => {
          this.tableForm.items = data.map((item) => {
            item.mfnFulfillmentLatencyOwn = item.mfnFulfillmentLatency;
            item.mfnQuantityOwn = item.mfnQuantity;
            return item;
          });
        })
        .complete(() => (this.loading = false));
    },
    verify() {
      this.$nextTick(() => {
        this.$refs.form.validate();
      });
    },
    tableVerify() {
      this.$nextTick(() => {
        this.$refs.tableForm.validate();
      });
    },
    radioChange() {
      this.form.price = '';
      this.form.salePrice = '';
    },
    deleteItem(index) {
      this.tableForm.items.splice(index, 1);
    },
    resolve() {
      if (this.$gjFormValidate()) {
        this.tableForm.items.forEach((v) => {
          v.mfnFulfillmentLatency = this.form.mfnFulfillmentLatency;
          if (this.mfnQuantityChange == 'fixed') {
            v.mfnQuantity = this.form.mfnQuantity;
          } else if (this.mfnQuantityChange == 'up') {
            v.mfnQuantity = +v.mfnQuantityOwn + +this.form.mfnQuantity;
          } else {
            v.mfnQuantity = v.mfnQuantityOwn - this.form.mfnQuantity;
          }
        });
      }
    },
    confirm() {
      if (this.tableFormValidate()) {
        this.loading = true;
        editBatchEditFulfillment({

          paramList: this.tableForm.items.map((v) => {
            return {
              listingId: v.listingId,
              mfnFulfillmentLatency: v.mfnFulfillmentLatency,
              mfnQuantity: v.mfnQuantity,
            };
          }),
        })
          .then(() => {
            this.$emit('after');
          })
          .complete(() => (this.loading = false));
      }
    },
    tableFormValidate() {
      let formValid = false;
      this.$refs.tableForm.validate((valid) => {
        formValid = valid;
      });
      return formValid;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .gj-table--has-picture td:not(.vxe-footer--column) {
  height: 65px !important;
}

.offer--content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.offer--setting {
  padding: 10px 20px 16px 10px;
}

.offer--table {
  flex: 1;
  margin: 0 20px;
  /* border-top: 1px solid #EBEEF5; */
}

.el-item-inline {
  margin-bottom: 0;
}

.apply-btn {
  margin-left: 20px;
  padding-top: 0;
}

.asin-msku_list {
  display: flex;

  a {
    color: #1f6eef;
    text-decoration-line: none;
  }

  .asin_list {
    flex: 10;
  }

  .msku_list {
    flex: 14;

    /deep/ .gj-tooltip {
      max-width: 86%;
    }
  }
}
.no-left-border {
  /deep/ .el-input__inner {
    border-left-color: transparent;
    &:hover,
    &:focus {
      border-left-color: #1f6eef;
    }
  }
}
.no-left-radius {
  /deep/ .el-input__inner {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}
</style>
